import React, { useEffect, useState } from 'react';
import { Box, Container, Paper, Typography, Button, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [showCookieNotice, setShowCookieNotice] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem('cookieConsent');
      if (consent !== 'accepted') {
        setShowCookieNotice(true);
      }
    } catch {
      // Если localStorage недоступен, просто показываем уведомление
      setShowCookieNotice(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    try {
      localStorage.setItem('cookieConsent', 'accepted');
    } catch {
      // игнорируем ошибки записи
    }
    setShowCookieNotice(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Container component="main" sx={{ flexGrow: 1, py: 4 }}>
        {children}
      </Container>
      {showCookieNotice && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: (theme) => theme.zIndex.snackbar,
            display: 'flex',
            justifyContent: 'center',
            px: 2,
            pb: 2,
          }}
        >
          <Paper
            elevation={6}
            sx={{
              maxWidth: 800,
              width: '100%',
              p: 2,
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'flex-start', sm: 'center' },
              gap: 2,
            }}
          >
            <Typography variant="body2">
              Используя наш сайт, вы соглашаетесь на использование файлов cookie, а также на обработку ваших
              персональных данных в соответствии с{' '}
              <Link
                component={RouterLink}
                to="/privacy-policy"
                color="primary"
                underline="hover"
              >
                политикой конфиденциальности
              </Link>
              .
            </Typography>
            <Box sx={{ ml: { sm: 'auto' } }}>
              <Button variant="contained" size="small" onClick={handleAcceptCookies}>
                Понятно
              </Button>
            </Box>
          </Paper>
        </Box>
      )}
      <Footer />
    </Box>
  );
}; 